<template>
  <div class="prizeshare-box">
    <div class="join-box">
       <button class="join-btn" @click="handleJoin">我要参加</button>
    </div>
    <div class="rule-box">
      <rule-list></rule-list>
    </div>
  </div>
</template>

<script>
import ruleList from './component/shareRule.vue'
import wxShare from '@/utils/share'
import { getWxConfig } from '@/api/drugPrize'

export default {
  components: {
    ruleList
  },
  data () {
    return {
      shareData: {
        link: '',
        title: '',
        desc: '',
        imgUrl: ''
      }
    }
  },
  created () {
    this.getWx()
  },
  methods: {
    getWx () {
      const url = window.location.href
      const requestData = {
        appId: 'wx1cb2ecbb4aec5713',
        url: url
      }
      getWxConfig(requestData).then((res) => {
        const data = res.data.result
        console.log(data)
        if (data) {
          wxShare(data, data)
        }
      })
    },
    handleJoin () {
      if (window._czc) {
        window._czc.push(['_trackEvent', '海天琴岛通', '我要参加', '分享页', '', '001'])
      }
      window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=com.bsit.coband'
    }
  }
}

</script>
<style lang='scss' scoped>
.prizeshare-box {
  min-height: 100vh;
  background: #EBF3FF;
}
.join-box {
  height: 100vh;
  position: relative;
  background: url('https://oss.aqdpay.com/appweb/drugPrize/bg.jpg') no-repeat left top;
  background-size: cover;
}
.join-btn {
  position: absolute;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  padding: 10px 40px;
  color: #fff;
  border-radius: 60px;
  border: 1px solid #fff;
  background: linear-gradient(180deg,#27acda, #3153bf);
  box-shadow: 0px 2px 4px 0px rgba(44,68,104,0.80);
}
.rule-box {
  padding: 18px 15px;
}
</style>
